import { initializeApp } from "firebase/app";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { AppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import firebaseConfig from "../firebase.config";
import { fetchAndActivate, getRemoteConfig, getValue } from "firebase/remote-config";

if (process.env.NODE_ENV === "development") {
  /**
   * @description Firebase app Debugging for development
   *
   * {@link https://firebase.google.com/docs/app-check/web/debug-provider#web}
   *
   * {@link https://console.firebase.google.com/u/0/project/output-development/appcheck/apps}
   */

  // @ts-ignore
  global.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN;
}

export const firebaseApp = initializeApp(firebaseConfig);

if (process.env.NODE_ENV === "development" && process.env.REACT_APP_FIREBASE_FUNCTIONS_LOCAL_EMULATORS === "true") {
  const functions = getFunctions(firebaseApp, "europe-west3");
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export const db = getFirestore(firebaseApp);
// Initialize Remote Config and get a reference to the service
export const remoteConfig = getRemoteConfig(firebaseApp);

remoteConfig.settings.minimumFetchIntervalMillis = Number(
  process.env.REACT_APP_REMOTE_CONFIG_MINIMUM_FETCH_INTERVAL_MILLIS
);

export let appCheck: AppCheck | undefined;

(async () => {
  await fetchAndActivate(remoteConfig);

  const HUB_ENABLE_FIREBASE_APPCHECK =
    new URL(window.location.href).searchParams.has("HUB_ENABLE_FIREBASE_APPCHECK") ||
    getValue(remoteConfig, "HUB_ENABLE_FIREBASE_APPCHECK").asBoolean();

  if (HUB_ENABLE_FIREBASE_APPCHECK && JSON.parse(process.env.REACT_APP_ENABLE_FIREBASE_APPCHECK || "false")) {
    if (!process.env.REACT_APP_FIREBASE_APPCHECK_RECAPTCHA_ID) {
      throw new Error("REACT_APP_FIREBASE_APPCHECK_RECAPTCHA_ID is not set");
    }

    // Pass your reCAPTCHA v3 site key (public key) to activate(). Make sure this
    // key is the counterpart to the secret key you set in the Firebase console.
    appCheck = initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(process.env.REACT_APP_FIREBASE_APPCHECK_RECAPTCHA_ID),

      // Optional argument. If true, the SDK automatically refreshes App Check
      // tokens as needed.
      isTokenAutoRefreshEnabled: true,
    });
  }
})();
